<template>
  <div
    v-show="shouldDisplay"
    class="landing-sticky-header"
  >
    <div class="landing-sticky-header-layout">
      <div class="landing-sticky-header__logo" />
      <BaseButton
        :text="$t('b2b_get_started_btn_text')"
        class="landing-sticky-header-cta-small"
        size="small"
        @click="handleCTAButtonClick"
      />
      <BaseButton
        :text="$t('b2b__landing_page__generic__cta_btn__claim_my_benefit')"
        class="landing-sticky-header-cta"
        @click="handleCTAButtonClick"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { debounce } from '@shared/utils'
import BaseButton from '@shared/components/BaseButton.vue'

const props = defineProps({
  handleCTAButtonClick: {
    type: Function,
    default: () => {},
  },
  showStickyHeader: {
    type: Function,
    default: () => {},
  },
})

const shouldDisplay = ref(false)
const debounceHandleScroll = ref(null)

const handleScroll = () => {
  shouldDisplay.value = props.showStickyHeader()
}

onMounted(() => {
  debounceHandleScroll.value = debounce(handleScroll, 10)
  window.addEventListener('scroll', debounceHandleScroll.value)

  shouldDisplay.value = props.showStickyHeader()
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', debounceHandleScroll.value)
  debounceHandleScroll.value = null
})
</script>

<style lang="scss">
.landing-sticky-header {
  position: fixed;
  z-index: 4;
  left: 0;
  right: 0;
  top: 0;
  background: $kds-color-background-base;
  box-shadow: 0 2px 2px rgba(10, 28, 64, 0.1);

  &-layout {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 65px;
    width: 100%;
    padding: 0 $kds-space-1_5x;
    box-sizing: border-box;

    @include media-up(sm) {
      padding: 0 $kds-space-3x;
    }

    @include media-up(md) {
      height: 77px;
      padding: 0 54px;
    }

    @include media-up(lg) {
      padding: 0 84px;
    }

    @include media-up(xl) {
      padding: 0 120px;
    }

    @include media-up(xxl) {
      width: 1200px;
      padding: 0;
      margin: 0 auto;
    }
  }

  &__logo {
    width: 100px;
    height: 15px;
    background-image: url('@shared/assets/img/kaia_text_logo.svg');
    background-position: left center;
    background-repeat: no-repeat;
    background-size: contain;

    @include media-up(md) {
      width: 180px;
      height: 26px;
    }
  }

  &-cta {
    width: 260px;
    display: none;

    @include media-up(md) {
      display: flex;
    }
  }
  &-cta-small {
    width: fit-content;
    @include media-up(md) {
      display: none;
    }
  }
}
</style>
